<template>
  <div class="company-cell">
    <div
      class="company-cell-item"
      v-for="(item, index) in baseInfo"
      :key="index"
    >
      <div class="num">{{ item.num }}</div>
      <div class="title">{{ item.title }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'company-code-cell',
  props: ['baseInfo'],
}
</script>
<style lang="scss" scoped>
.company-cell {
  padding: 16px 0;
  display: flex;
  border: 1px solid #eff0f2;
  background-color: #fff;
}

.company-cell-item {
  text-align: center;
  flex: 1;
  .num {
    font-size: 24px;
    font-weight: 400;
    padding-bottom: 6px;
  }
  .title {
    font-size: 12px;
    color: #999;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/practice/company-code-cell/index.vue